import axios from "axios"

export default function getPointCut({ id }) {
    return new Promise((resolve, reject) => {
        axios.get(`/campaign/api/admin/items-setting/${id}`)
            .then(response => resolve(response.data))
            .catch(error => reject(error.response.data))
    })
}